import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ConfirmDialog from '../../components/abstractObjects/ConfirmDialog'
import { Grid, Button, Box } from '@material-ui/core'
import { AttachmentsForm, AttachmentsUI } from './attachmentsForm'
import { selectVarById, deleteAttachment, toggleAttachmentView } from '../var/varSlice'
import { BasicLabel } from '../../components/abstractObjects/Label'


export const VarAttachmentsForm = ({ label, varId, varFieldAttachmentId, fileTypes = null }) => {
    const dispatch = useDispatch()
    let deleteObj = (varId, attachmentId) => {
        dispatch(
            deleteAttachment({
                VarTransactionId: varId,
                Id: attachmentId
            })
        )
    }
    let attachmentId = useSelector((state) => state.singleVar.attachmentId)
    const varx = useSelector((state) => selectVarById(state, varId))

    let varToggleAttachmentView = useSelector((state) => state.singleVar.toggleAttachmentView[varFieldAttachmentId])
    const onToggleView = (e, AttachmentId = null, VarFieldAttachmentId = null) => {
        e.preventDefault()
        if (AttachmentId === null) dispatch(toggleAttachmentView({ AttachmentId, VarFieldAttachmentId }))
    }
    const updateObj = () => {
        if (!varToggleAttachmentView) return true
        return updateAttachmentsForm()
    }

    var [backToList, validateForm, updateAttachmentsForm] = AttachmentsForm({ varId, varFieldAttachmentId })
    var c = 0
    const content = varx.VarAttachments.map((object) => {
        if (object.VarFieldAttachmentId != varFieldAttachmentId) return <React.Fragment key={c++} />
        return (<React.Fragment key={c++}>
            <Grid item xs={10} sm={5} md={3} align="flex-start">
                <Box align="center" mb="0.5rem" mt="1rem">
                    {
                        object.Extension == ".pdf" ?
                            <span onClick={() => {
                                window.open(object.Url ?? `/VarTransactions/DownloadFile?extension=${object.Extension}&nameFile=${object.ImageFile}&varId=${object.VarTransactionId}&urlFile=${object.Url != undefined ? object.Url : ""}`);
                            }}>
                                <i className="fa fa-file-pdf" style={{ color: "red", fontSize: 100 }} aria-hidden="true" />
                            </span> :
                            <img src={object.Url} style={{ backgroundColor: "grey", minHeight: 20, width: "100%" }} alt=""></img>
                    }
                </Box>
            </Grid>
            {varx.ImSupervisor ? <Grid item xs={2} sm={1} md={1} /> :
                <Grid item xs={2} sm={1} md={1}>
                    <ConfirmDialog message="Do you really want to delete it?" header="Remove" agreeFunction={() => deleteObj(varx.Id, object.Id)}>
                        <Button color="primary" style={{ fontSize: "1.7rem", padding: "auto" }}>
                            <i className="fas fa-trash" style={{ fontSize: "1.75rem", fontWeight: 500 }} />
                        </Button>
                    </ConfirmDialog>
                </Grid>}
        </React.Fragment>)
    })

    let DefaultView = () => {
        var c = 0
        var i = 100
        return (
            <React.Fragment key={++c}>
                <Grid container>
                    <Grid item xs={10} style={{ marginBottom: "0.75em" }}>
                        <h5><BasicLabel text={label ?? "Attachments"} /></h5>
                    </Grid>
                    <Grid item xs={2} style={{ marginBottom: "0.75em" }}>
                        {varx.ImSupervisor ? '' :
                            (<Button key={++i} color="primary" onClick={(e) => onToggleView(e, null, varFieldAttachmentId)} style={{ fontSize: "1.7rem", padding: "auto" }}>
                                <i className="fas fa-plus"></i>
                            </Button>)}
                    </Grid>
                </Grid>
                <Grid container>
                    {content}
                </Grid>
            </React.Fragment>
        )
    }

    let contentView
    if (varToggleAttachmentView) {
        contentView = <AttachmentsUI AttachmentsData={{ varId }} acceptedFiles={fileTypes} saveObj={updateAttachmentsForm} backToList={backToList} validateForm={validateForm} />
    } else {
        contentView = <DefaultView attachmentId={attachmentId} />
    }
    const ui = (
        <div>{contentView}</div>
    )

    return [ui, updateObj];
}

export const VarAttachmentsView = ({ label, varId, varFieldAttachmentId }) => {
    const varx = useSelector((state) => selectVarById(state, varId))
    var c = 0
    const content = varx.VarAttachments.map((object) => {
        if (object.VarFieldAttachmentId != varFieldAttachmentId) return <React.Fragment key={c++} />
        return (<React.Fragment key={`${varFieldAttachmentId}-${c++}`}>
            <Grid item xs={12} sm={6} md={4} align="flex-start">
                <Box align="center" mb="0.5rem" mt="1rem">
                    {
                        object.Extension == ".pdf" ?
                            <span onClick={() => {
                                window.open(object.Url ?? `/VarTransactions/DownloadFile?extension=${object.Extension}&nameFile=${object.ImageFile}&varId=${object.VarTransactionId}&urlFile=${object.Url != undefined ? object.Url : ""}`)
                            }}>
                                <i className="fa fa-file-pdf" style={{ color: "red", fontSize: 100 }} aria-hidden="true" />
                            </span> :
                            <img src={object.Url} style={{ backgroundColor: "grey", minHeight: 20, width: "100%" }} alt=""></img>
                    }
                </Box>
            </Grid>
        </React.Fragment>)
    })
    return (
        <React.Fragment key={`${varFieldAttachmentId}-${c++}`}>
            <Grid container>
                <Grid item xs={12} style={{ marginBottom: "0.75em" }}>
                    <h5><BasicLabel text={label ?? "ATTACHMENTS"} /></h5>
                </Grid>
            </Grid>
            <Grid container>
                {content}
            </Grid>
        </React.Fragment>
    )
} 

export default VarAttachmentsForm